import StateComponent from '../../../../StateComponent'

export default class DescriptionStrategy extends StateComponent {
    getHeader() {
        return ''
    }

    getDescription() {
        return ''
    }

    getGenerateCallback() {
        return () => {}
    }

    getDetailsCallback() {
        return () => {}
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/DescriptionStrategy.js